export enum DisplayEventType {
    periodStart = "periodStart",
    periodEnd = "periodEnd",
    nonPlayingPeriod = "nonPlayingPeriod",
    stoppage = "stoppage",
    suspension = "suspension",
    oneMinuteTimer = "oneMinuteTimer",
    other = "other",
}
